import { useStore } from "vuex";
import CircleType from 'circletype';
import { computed, ref, nextTick } from 'vue';

const UseTireMeasure = () => {
  const config = useRuntimeConfig();
  const store = useStore();
  const { ubication } = useCartBridge();

  const router = useRouter();

  const debug = {
    enabled: config.public.modo === 'DEV',
    log(...args) { if (this.enabled) console.log(...args); },
    error(...args) { if (this.enabled) console.error(...args); },
  };

  const BRANDS = 'brands';
  const YEARS = 'years';
  const MODELS = 'models';
  const VERSIONS = 'versions';

  const cookieMedidasFlujoMedida = useCookie('measure');
  const cookieMedidasFlujoAuto = useCookie('MedidasFlujoAuto');
  const vehicleData = computed(() => store.state.plpModule.vehicleData);

  const isLoadingSequence = ref(false);

  const widths = ref([]);
  const perfiles = ref([]);
  const rings = ref([]);
  const regions = ref([]);
  const communes = ref([]);
  const brands = ref([]);
  const years = ref([]);
  const models = ref([]);
  const versions = ref([]);

  const selectedWidth = ref('');
  const selectedTireProfile = ref('');
  const selectedRing = ref('');
  const selectedRegion = ref('');
  const selectedCommune = ref('');
  const selectedBrand = ref('');
  const selectedYear = ref('');
  const selectedModel = ref('');
  const selectedVersion = ref('');
  const selectSeleccionado = ref('Ancho');

  const loadingWidths = ref(false);
  const loadingperfiles = ref(false);
  const loadingRings = ref(false);
  const loadingRegions = ref(false);
  const loadingCommunes = ref(false);
  const loadingBrands = ref(false);
  const loadingYears = ref(false);
  const loadingModels = ref(false);
  const loadingVersions = ref(false);

  const circularText = ref(null);
  const showErrorModalApi = ref(false);
  const messageErrorApi = ref('');

  const { getWidthsData, getProfilesData, getRingsData } = useErpApi();
  const { getBrands, getYears, getModels, getVersions, getCars } = useWheelSize();

  //#region FUNCIONES DE UTILIDAD
  const safeDestroy = () => {
    if (circularText.value && typeof circularText.value.destroy === 'function') {
      circularText.value.destroy();
      circularText.value = null;
    }
  };

  const saveToSessionStorage = (key, value) => {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        data: value,
        brand: selectedBrand.value,
        year: selectedYear.value,
        model: selectedModel.value,
        version: selectedVersion.value
      })
    );
  };

  const readFromSessionStorage = key => {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  };

  // Lee marcas desde sessionStorage y las carga en brands sin llamar a la API
  const loadChargedData = () => {
    const storedBrands = readFromSessionStorage(BRANDS);
    if (storedBrands && storedBrands.data.length > 0) {
      brands.value = storedBrands.data;
      return true;
    }
    return false;
  };

  const orderWidthData = widths => {
    const widthsAux = widths.filter(width => width <= 39);
    widths = widths.filter(width => width > 39);
    widths = widths.concat(widthsAux);
    return widths;
  };

  const obtenerPosicion = (caracter = '/') => {
    let posicionCaracter;
    const posicion = document.querySelectorAll('#tyre-text-container span');
    posicion.forEach((span, i) => {
      if (span.textContent == caracter) {
        posicionCaracter = i - 1;
      }
    });
    return posicionCaracter;
  };

  const focusInputConRetry = async (maxAttempts = 2, delayBetweenAttempts = 600, inputIndex = 1) => {
    const inputs = document.querySelectorAll('input.resaltar_programatico');
    if (inputs.length === 0) return false;

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        const targetInput = inputIndex < inputs.length
          ? inputs[inputIndex]
          : inputs[inputs.length - 1];

        if (targetInput && !targetInput.disabled && getComputedStyle(targetInput).display !== 'none') {
          targetInput.focus();
          return true;
        } else {
          throw new Error('Input no disponible');
        }
      } catch (error) {
        if (attempt < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, delayBetweenAttempts));
        }
      }
    }
    return false;
  };
  //#endregion FUNCIONES DE UTILIDAD

  //#region FUNCIONES DE VALIDACIÓN
  const isDisabled = computed(() => {
    const missingFields = [];
    if (!selectedWidth.value) missingFields.push('Ancho');
    if (!selectedTireProfile.value) missingFields.push('Perfil');
    if (!selectedRing.value) missingFields.push('Aro');
    if (!ubication.value.latitude || !ubication.value.longitude) missingFields.push('Ubicación');
    return missingFields.length > 0;
  });

  const isDisabledCar = computed(() => {
    return !(selectedBrand.value &&
      selectedYear.value &&
      selectedModel.value &&
      selectedVersion.value &&
      ubication.value.latitude &&
      ubication.value.longitude);
  });
  //#endregion FUNCIONES DE VALIDACIÓN

  //#region FUNCIONES DE TEXTO CIRCULAR
  const curvarTexto = async () => {
    await nextTick();
    const contenedorTexto = document.querySelector('#tyre-text-container');
    if (contenedorTexto) {
      safeDestroy();
      circularText.value = new CircleType(contenedorTexto);
      circularText.value.radius(window.innerWidth < 768 ? 120 : 200);
    }
  };

  const cambiarAnchoTextoCurvo = async () => {
    await nextTick();
    const contenedorTexto = document.querySelector('#tyre-text-container');
    if (!contenedorTexto) return;

    safeDestroy();
    circularText.value = new CircleType(contenedorTexto);
    circularText.value.radius(window.innerWidth < 768 ? 120 : 200);

    const position = document.querySelectorAll('#tyre-text-container span');
    const posicionCaracter = obtenerPosicion('/');
    for (let i = posicionCaracter; i >= 0; i--) {
      position[i].style.color = 'red';
    }
  };

  const cambiarPerfilTextoCurvo = async () => {
    await nextTick();
    const contenedorTexto = document.querySelector('#tyre-text-container');
    if (!contenedorTexto) return;

    safeDestroy();
    circularText.value = new CircleType(contenedorTexto);
    circularText.value.radius(window.innerWidth < 768 ? 120 : 200);

    const position = document.querySelectorAll('#tyre-text-container span');
    const posicionCaracter = obtenerPosicion('/');
    for (let i = posicionCaracter + 2; i >= 0; i--) {
      if (position[i] && position[i].textContent === 'R') break;
      position[i].style.color = 'red';
    }
  };

  const cambiarAroTextoCurvo = async () => {
    await nextTick();
    const contenedorTexto = document.querySelector('#tyre-text-container');
    if (!contenedorTexto) return;

    safeDestroy();
    circularText.value = new CircleType(contenedorTexto);
    circularText.value.radius(window.innerWidth < 768 ? 120 : 200);

    const position = document.querySelectorAll('#tyre-text-container span');
    const posicionCaracter = obtenerPosicion('R');
    for (let i = posicionCaracter; i < position.length; i++) {
      position[i].style.color = 'red';
    }
  };
  //#endregion FUNCIONES DE TEXTO CIRCULAR

  //#region FUNCIONES PARA BÚSQUEDA POR MEDIDAS
  const getWidths = async () => {
    try {
      loadingWidths.value = true;
      const response = await getWidthsData();
      widths.value = response.sort((a, b) => a - b);
      widths.value = orderWidthData(widths.value);
    } catch (error) {
      console.error(error);
    } finally {
      loadingWidths.value = false;
    }
  };

  const onCambiarAncho = async (width) => {
    try {
      safeDestroy();

      const numberOne = document.querySelector('.number-one');
      if (numberOne) {
        numberOne.textContent = width;
        await cambiarAnchoTextoCurvo();
      }

      loadingperfiles.value = true;
      perfiles.value = [];
      rings.value = [];
      selectedWidth.value = width;
      selectedTireProfile.value = '';
      selectedRing.value = '';

      const response = await getProfilesData(width);
      perfiles.value = response.sort((a, b) => a - b);
      selectSeleccionado.value = 'Perfil';
    } catch (error) {
      console.error("ERROR en onCambiarAncho:", error);
      throw error;
    } finally {
      loadingperfiles.value = false;
    }
  };

  const onCambiarPerfil = async (tireProfile) => {
    try {
      safeDestroy();

      const numberTwo = document.querySelector('.number-two');
      if (numberTwo) {
        numberTwo.textContent = tireProfile;
        await cambiarPerfilTextoCurvo();
      }

      loadingRings.value = true;
      selectedTireProfile.value = tireProfile;
      selectedRing.value = '';
      rings.value = [];

      const response = await getRingsData(selectedWidth.value, selectedTireProfile.value);
      rings.value = response.sort((a, b) => a - b);
      selectSeleccionado.value = 'Aro';
    } catch (error) {
      console.error("ERROR en onCambiarPerfil:", error);
      throw error;
    } finally {
      loadingRings.value = false;
    }
  };

  const onCambiarAro = async (ring) => {
    safeDestroy();

    const numberThree = document.querySelector('.number-three');
    if (numberThree) {
      numberThree.textContent = ring;
      await cambiarAroTextoCurvo();
      await focusInputConRetry(2, 500, 1);
    }

    selectedRing.value = ring;
  };
  //#endregion FUNCIONES PARA BÚSQUEDA POR MEDIDAS

  //#region FUNCIONES PARA BÚSQUEDA POR VEHÍCULO
  const getMarcas = async () => {
    try {
      loadingBrands.value = true;
      const response = await getBrands();
      brands.value = response;
      saveToSessionStorage(BRANDS, brands.value);
    } catch (error) {
      console.error(error);
      messageErrorApi.value = 'Hubo un error al cargar las marcas. Por favor, intente más tarde.';
    } finally {
      loadingBrands.value = false;
    }
  };

  const onChangeBrand = async brand => {
    try {
      selectedBrand.value = brand;

      const cacheYears = readFromSessionStorage(YEARS);
      if (!cacheYears || selectedBrand.value != cacheYears.brand) {
        loadingYears.value = true;
        years.value = [];
        models.value = [];
        versions.value = [];
        selectedYear.value = '';
        selectedModel.value = '';
        selectedVersion.value = '';

        const response = await getYears(brand);
        years.value = response;
        saveToSessionStorage(YEARS, years.value);
      } else {
        years.value = cacheYears.data;
      }

      selectSeleccionado.value = 'Año';
    } catch (error) {
      console.error(error);
      messageErrorApi.value = 'Hubo un error al cargar los años. Por favor, intente más tarde.';
    } finally {
      loadingYears.value = false;
    }
  };

  const onChangeYear = async year => {
    try {
      selectedYear.value = year;

      const cacheModels = readFromSessionStorage(MODELS);
      if (!cacheModels || selectedYear.value != cacheModels.year || selectedBrand.value != cacheModels.brand) {
        loadingModels.value = true;
        models.value = [];
        versions.value = [];
        selectedModel.value = '';
        selectedVersion.value = '';

        const response = await getModels(selectedBrand.value, year);
        models.value = response;
        saveToSessionStorage(MODELS, models.value);
      } else {
        models.value = cacheModels.data;
      }

      selectSeleccionado.value = 'Modelo';
    } catch (error) {
      console.error(error);
      messageErrorApi.value = 'Hubo un error al cargar los modelos. Por favor, intente más tarde.';
    } finally {
      loadingModels.value = false;
    }
  };

  const onChangeModel = async model => {
    try {
      selectedModel.value = model;

      const cacheVersions = readFromSessionStorage(VERSIONS);
      if (!cacheVersions || selectedModel.value != cacheVersions.model || selectedYear.value != cacheVersions.year || selectedBrand.value != cacheVersions.brand) {
        loadingVersions.value = true;
        versions.value = [];
        selectedVersion.value = '';

        const response = await getVersions(selectedBrand.value, selectedYear.value, model);
        versions.value = response;
        saveToSessionStorage(VERSIONS, versions.value);
      } else {
        versions.value = cacheVersions.data;
      }

      selectSeleccionado.value = 'Versión';
    } catch (error) {
      console.error(error);
      messageErrorApi.value = 'Hubo un error al cargar las versiones. Por favor, intente más tarde.';
    } finally {
      loadingVersions.value = false;
    }
  };

  const onChangeVersion = async version => {
    selectedVersion.value = version;
    await focusInputConRetry(2, 500, 0);
  };
  //#endregion FUNCIONES PARA BÚSQUEDA POR VEHÍCULO

  //#region FUNCIONES DE ALMACENAMIENTO Y NAVEGACIÓN
  const storeMedidaYAvanzar = () => {
    if (selectedWidth.value && selectedTireProfile.value && selectedRing.value) {
      cookieMedidasFlujoAuto.value = null;
      store.commit('plpModule/removeVehicleData');

      cookieMedidasFlujoMedida.value = {
        width: selectedWidth.value,
        profile: selectedTireProfile.value,
        ring: selectedRing.value
      };

      router.push(`/neumaticos/plp/${selectedWidth.value}-${selectedTireProfile.value}-${selectedRing.value}`);
    }
  };

  const storeAutoYAvanzar = async () => {
    try {
      if (selectedBrand.value && selectedYear.value && selectedModel.value && selectedVersion.value) {
        cookieMedidasFlujoMedida.value = null;
        cookieMedidasFlujoAuto.value = null;
        store.commit('plpModule/removeVehicleData');

        const datos_vehiculo = await getCars(
          selectedBrand.value,
          selectedYear.value,
          selectedModel.value,
          selectedVersion.value
        );

        if (datos_vehiculo.length > 0) {
          let imgSource = store.state.plpModule.selectedBrandLogo || '';
          datos_vehiculo[0].brand_image = imgSource;
          store.commit('plpModule/updateVehicleData', datos_vehiculo);
          router.push(`/neumaticos/vehicle`);
        } else {
          showErrorModalApi.value = true;
          messageErrorApi.value = 'No se encontraron neumáticos para el vehículo seleccionado';
        }
      }
    } catch (error) {
      console.error("ERROR en storeAutoYAvanzar:", error);
      messageErrorApi.value = 'Hubo un error al obtener los datos del vehículo. Por favor, intente más tarde.';
    }
  };
  //#endregion FUNCIONES DE ALMACENAMIENTO Y NAVEGACIÓN

  //#region FUNCIONES DE INICIALIZACIÓN
  const inicializarDesdeCookie = async () => {
    if (cookieMedidasFlujoMedida.value) {
      isLoadingSequence.value = true;

      if (cookieMedidasFlujoMedida.value.width) {
        await onCambiarAncho(cookieMedidasFlujoMedida.value.width);

        if (cookieMedidasFlujoMedida.value.profile) {
          await new Promise(resolve => setTimeout(resolve, 50));
          await onCambiarPerfil(cookieMedidasFlujoMedida.value.profile);

          if (cookieMedidasFlujoMedida.value.ring) {
            await new Promise(resolve => setTimeout(resolve, 50));
            await onCambiarAro(cookieMedidasFlujoMedida.value.ring);
          }
        }
      }

      selectSeleccionado.value = '';
      isLoadingSequence.value = false;
    }
  };
  //#endregion FUNCIONES DE INICIALIZACIÓN

  //#region FUNCIONES DE UI
  const onChangeCommune = commune => {
    selectedCommune.value = commune;
  };

  const closeErrorModalApi = () => {
    showErrorModalApi.value = false;
  };
  //#endregion FUNCIONES DE UI

  return {
    widths, perfiles, rings, regions, communes,
    brands, years, models, versions,

    selectedWidth, selectedTireProfile, selectedRing,
    selectedRegion, selectedCommune,
    selectedBrand, selectedYear, selectedModel, selectedVersion,
    selectSeleccionado,

    loadingWidths, loadingperfiles, loadingRings,
    loadingRegions, loadingCommunes,
    loadingBrands, loadingYears, loadingModels, loadingVersions,

    showErrorModalApi, messageErrorApi,

    onCambiarAncho, onCambiarPerfil, onCambiarAro, getWidths,
    onChangeBrand, onChangeYear, onChangeModel, onChangeVersion, getMarcas,
    onChangeCommune,
    storeMedidaYAvanzar, storeAutoYAvanzar,
    isDisabled, isDisabledCar,
    curvarTexto, cambiarAnchoTextoCurvo, cambiarPerfilTextoCurvo, cambiarAroTextoCurvo,
    closeErrorModalApi,
    inicializarDesdeCookie,
    safeDestroy,
    isLoadingSequence,
    loadChargedData,
  };
};

export default UseTireMeasure;